import Procedimento from "@/model/Procedimento";
import { AxiosInstance } from "axios";

export default (httpClient: AxiosInstance) => ({
    Listar: async () => {
        const response = await httpClient.get(`/Procedimento/listar`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    ListarPorId: async (pId : number) => {
        const response = await httpClient.get(`/Procedimento/id?id=${pId}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Inserir: async (pProcedimento : Procedimento) => {
        const response = await httpClient.post(`/Procedimento/inserir`, pProcedimento);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Alterar: async (pProcedimento: Procedimento) => {
        const response = await httpClient.post(`/Procedimento/alterar`, pProcedimento);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Excluir: async (pId : number) => {
        const response = await httpClient.post(`/Procedimento/excluir?id=${pId}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },

});